import { Injectable } from '@angular/core';
import { _Service } from './_service';
import { AppId, Team, User } from '../../model';
import { AuthUser } from '../auth';

export interface TokenResponse {
  token: AppId;
}

export interface ErrorResponse {
  error: boolean;
}

export interface NewsletterStatusResponse {
  active: boolean;
  email: string;
}

export const isErrorResponse = (response: any): response is ErrorResponse => 'error' in response && response.error;

@Injectable({ providedIn: 'root' })
export class UserService extends _Service<User> {
  constructor() {
    super('api/user');
  }

  profile = async () => this.http.get<User>(`api/user/profile`);
  updateProfile = async (data: User) => this.http.put<User & { authToken?: string }>('api/user/profile', data);
  team = async () => this.http.get<Team>('api/user/team');
  fetchTeamToken = async () => this.http.get<TokenResponse>('api/user/team/token');
  revokeTeamToken = async () => this.http.delete<TokenResponse>('api/user/team/token');
  migrateTeamMember = async (token: string) => this.http.post<Team | ErrorResponse>('api/user/team', { token });
  inviteTeamMember = async (name: string, email: string) =>
    this.http.post<Team | ErrorResponse>('api/user/team/invite', { name, email });
  removeTeamMember = async (user: User) => this.http.delete<Team>(`api/user/team/${user.id}`);
  updateTeam = async (team: Team) => this.http.put<Team>('api/user/team', team);
  impersonate = async (user: User) => this.http.get<AuthUser>(`api/user/impersonate/${user.id}`);
  all = async () => this.http.get<User[]>(`api/user/all`);
  startTour = async (tourId: string) => this.http.post(`api/user/profile/tours/${tourId}/start`, {});
  updateTourProgress = async (tourId: string, step: number) =>
    this.http.put(`api/user/profile/tours/${tourId}/progress`, { step });
  finishTour = async (tourId: string) => this.http.post(`api/user/profile/tours/${tourId}/finish`, {});
  abandonTour = async (tourId: string) => this.http.post(`api/user/profile/tours/${tourId}/abandon`, {});
  setLastSelectedCompany = async (siteId: string) =>
    this.http.put<User>('api/user/profile/last-selected-company', { siteId });
  unsubscribeNewsletter = async (email: string, token: string) =>
    this.http.post('api/newsletter/unsubscribe', { email, token });
  newsletterStatus = async (email: string, token: string) =>
    this.http.get<NewsletterStatusResponse>(
      `api/newsletter/unsubscribe?email=${encodeURIComponent(email)}&token=${encodeURIComponent(token)}`
    );
}
